<template>
  <BootstrapModal class="EditPackage"
                  v-on="$listeners"

                  @save="saveEditorPackage"
  >
    <div>
      <FormInput
        class="form-element"
        v-model="$v.name.$model"

        id="name"
        label="Naam"

        :vuelidate="$v"
        fieldName="name"
      />
      <div>
        <FormInput
          class="form-element"
          v-model="$v.module_id.$model"

          id="module_id"
          label="Module-ID"

          :vuelidate="$v"
          fieldName="module_id"
        />
      </div>
      <p style="font-size: 13px">
        Note: The "module_id" is the name of the folder in PHP, on the "Backoffice\Editor\Block\Themes" folder.
      </p>
    </div>

    <template #title>
      {{ editorPackage ? "Editor-pakketten bewerken" : "Editor-pakketten toevoegen" }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"

import FormInput from "src/components/Inputs/FormInput.vue"

import { required } from "vuelidate/lib/validators"

export default {
  props: ["editorPackage", "callback"],
  components: {
    BootstrapModal,
    FormInput,
  },
  validations: {
    name: {
      required,
    },
    module_id: {
      required,
    },
  },
  data() {
    return {
      name: "",
      module_id: "",
    }
  },
  created() {
    if (this.editorPackage) {
      this.$v.name.$model = this.editorPackage.name
      this.$v.module_id.$model = this.editorPackage.module_id
    }
  },
  methods: {
    saveEditorPackage: function () {
      this.$v.$touch()
      if (this.$v.$error) return;

      const payload = {
        name: this.$v.name.$model,
        module_id: this.$v.module_id.$model,
      }

      this.$handlePromise(async () => {
        if (this.editorPackage) {
          await this.axios.put(`/api/editor-packages/${this.editorPackage.uid}`, payload)
        } else {
          await this.axios.post(`/api/editor-packages`, payload)
        }

        this.$success("Editor-pakketten succesvol opgeslagen!")
        this.callback && this.callback()
        this.$emit("close")
      })
    },
  },
}

</script>

<style scoped>

.EditPackage {
  flex-basis: 500px;
}

</style>
